module.exports = __webpack_public_path__ + "img/wind-house.ab38591e.png";